import React from 'react'
import ReactDOM from 'react-dom'
import App from './js/App'
import * as Sentry from '@sentry/react'
import { BrowserTracing } from '@sentry/tracing'

//Sentry for Error and Performance logging
if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://ffc54a3b99944810863e145e58a51e16@o1230864.ingest.sentry.io/6384987',
    integrations: [new BrowserTracing()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.5,
  })
}

ReactDOM.render(<App />, document.getElementById('app'))
